import { useContext } from 'react';
import { EmbeddedAppContext } from './EmbeddedAppContext';

export const useRouteBase = (): string => {
  const embeddedAppData = useContext(EmbeddedAppContext);
  return embeddedAppData.baseRoute ? `/${embeddedAppData.baseRoute}` : '';
};
